var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailActionEdit = function SvgEmailActionEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3467 39.6533L40 60L30 62L32 52L52.3467 31.6533C52.8703 31.1289 53.4921 30.7128 54.1766 30.429C54.8612 30.1451 55.5949 29.999 56.336 29.999C57.0771 29.999 57.8108 30.1451 58.4954 30.429C59.1799 30.7128 59.8017 31.1289 60.3253 31.6533L60.3467 31.6746C60.8711 32.1982 61.2871 32.8201 61.571 33.5046C61.8548 34.1891 62.0009 34.9229 62.0009 35.664C62.0009 36.405 61.8548 37.1388 61.571 37.8233C61.2871 38.5079 60.8711 39.1297 60.3467 39.6533V39.6533Z",
    stroke: "#0058FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42H6C4.93913 42 3.92172 41.5786 3.17157 40.8284C2.42143 40.0783 2 39.0609 2 38V6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2H54C55.0609 2 56.0783 2.42143 56.8284 3.17157C57.5786 3.92172 58 4.93913 58 6V22",
    stroke: "#80ABFF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0961 3.4668L35.3787 20.1708C33.8366 21.3571 31.9456 22.0003 30.0001 22.0003C28.0545 22.0003 26.1635 21.3571 24.6214 20.1708L2.90405 3.4668",
    stroke: "#80ABFF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailActionEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-action-edit.21f2c323.svg";
export { ForwardRef as ReactComponent };